module.exports = __webpack_public_path__ + "img/diary.42a777e7.svg";